import React, {useEffect, useRef, useState} from "react";
import { capitalizeFirstLetters /*, completeOAuth */ } from "../../../../utils";
import { completeOAuth, useIntegration } from "../../../../hooks/useIntegrations";
import {useAuth0} from "@auth0/auth0-react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import { AuthType } from "../types";
import { CompleteIntegrationAuth as CompleteIntegrationAuthLegacy } from "./CompleteIntegrationAuth";
import { SourceIcon } from "../../../../utils/SourceIcon";
import { Box, Button, Loader } from "@mantine/core";

export const CompleteIntegrationAuth = () => {
  const auth0 = useAuth0();
  const location = useLocation();
  const navigate = useNavigate();
  
  const { key } = useParams(); 
  const { 
    data: integration,
    isLoading,
    error: getIntegrationError
  } = useIntegration(key || '');


  if(
    // @ts-ignore
    integration?.available?.oauth?.metadata?.completeCallback === "legacy"
  ){
    return <CompleteIntegrationAuthLegacy />
  }
  
  const [timesRun, setTimesRun] = useState(0);
  const counter = useRef<number>(0);
  const effectCalled = useRef<boolean>(false);
  const [completed, setCompleted] = useState<boolean>(false);
  const [integrationName, setIntegrationName] = useState<string>("New Source");
  const [integrationType, setIntegrationType] = useState<string>("");
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (effectCalled.current) return;
    counter.current += 1;
    setTimesRun(counter.current);
    effectCalled.current = true;
    console.log(location.search)
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const stateBase64 = params.get("state");
    
    if (code && stateBase64) {
      const metadata = JSON.parse(atob(stateBase64));
      if (metadata.integrationType) {
        const integrationKey = metadata.integrationType;
        setIntegrationName(capitalizeFirstLetters(integrationKey));
        setIntegrationType(integrationKey);
        
        auth0.getAccessTokenSilently()
          .then(async (token: any) => {
            try {
              await completeOAuth(token, integrationKey, code, metadata.subdomain);
              navigate(`/settings/integrations2.0/${integrationKey}`);
            } catch (e: any) {
              console.log(e);
              setError("Integration failed: " + e.toString());
            } finally {
              setCompleted(true);
            }
          })
          .catch((e: any) => {
            console.log(e);
            setError("Authentication failed: " + e.toString());
            setCompleted(true);
          });
      } else {
        console.log("bad state");
        setError("Integration failed: invalid state data");
        setCompleted(true);
      }
    } else {
      setError("Integration failed: did not receive integration code");
      setCompleted(true);
    }
  }, []);

  return (
    <div className="integrations">
      {!completed && (
        <>
          <SourceIcon sourceName={key || ''} width={40} height={40} />
          <h1>Connecting {integrationName}</h1>
          <Loader />
        </>
      )}
      {completed && !error && <Box> 
        <Box>
          <SourceIcon sourceName={key || ''} width={40} height={40} />
          <h1>Integration Complete</h1> 
        </Box>
        <Button variant="light" color="indigo" onClick={() => navigate(`/settings/integrations2.0/${key}`)}>
          Go to Integration
        </Button>
      </Box>}
      {completed && error && <h1>{error}</h1>}
    </div>
  );
} 